<template>
  <div class="results helpmobile">
     <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>移动端助手 </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="results-wrap">
      <div class="headtitle">移动端助手功能介绍</div>
      <div class="headdesc">移动端助手提供丰富的进出口信息查询功能，可以查询出口税率，进口税率，海关汇率，反倾销反补贴信息等等，同时还会根据不同政务平台的具体需求，结合当地产业特色，将不同功能融合在一起，打造个性化、高适配的工具集成助手。</div>
      <div class="s1">
        <div class="s1Wrap">
          <div class="title">功能汇总：</div>
          <Row :gutter="60" type="flex">
            <Col span="8">
              <div class="wrap">
                <div class="item">智能归类</div>
                <div class="item">原产地查询</div>
                <div class="item">税率查询</div>
                <div class="item">涉证涉检查询</div>
              </div>
            </Col>
            <Col span="8">
              <div class="wrap">
                <div class="item">中美加征</div>
                <div class="item">双反查询</div>
                <div class="item">CIQ查询</div>
                <div class="item">3C认证</div>
              </div>
            </Col>
            <Col span="8">
              <div class="wrap">
                <div class="item">出口退税查询</div>
                <div class="item">商品税费预估</div>
                <div class="item">消费税率查询</div>
                <div class="item">海关汇率查询</div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s2">
        <div class="s2Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/a1.png" alt=""><div>智能归类</div></div></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/a2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/a3.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/a4.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/a5.png" alt=""></Col>
          </Row>
          <Row type="flex">
            <Col span="5">&nbsp;</Col>
            <Col span="19">
              <div class="ssdesc">根据海关申报大数据为依托，对企业需要归类的商品信息进行<span>智能分析匹配</span>，根据人工智能算法推荐企业最合适的商品归类编码，让进出口企业归类不再困难。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s3">
        <div class="s3Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/b1.png" alt=""><div>原产地查询</div></div></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/b2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/b3.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
          </Row>
          <Row type="flex">
            <Col span="5">&nbsp;</Col>
            <Col span="19">
              <div class="ssdesc">提供商品在特定自由贸易协定下的商品原产地规则、商品原产地附加规则信息、商品原产地证书填制规范及原产地证书样例等信息。系统具备分析功能，根据多个维度，为企业分析关税优惠力度和相应原产地规则的宽严度，有多套自贸协定可选择的企业提供最优的自贸协定方案的指引。</div>
              <div class="ssdesc">需要强调的是，目前各政府部门公布的原产地规则法律文本是基于WCO 2012/2017年版的协调制度进行谈判和制定的。该系统提供的相关信息是基于WCO <span>2022年版的协调制度</span>进行转换的，是目前市场上最新的原产地规则信息。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s4">
        <div class="s4Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/c1.png" alt=""><div>税率查询</div></div></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/c2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/c3.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
          </Row>
          <Row type="flex">
            <Col span="5">&nbsp;</Col>
            <Col span="19">
              <div class="ssdesc">根据进出口商品的海关HS编码，为企业提供商品的RCEP协定优惠税率信息。系统具备分析功能，在众多进口关税中（普通关税、最惠国关税、暂定关税、协定关税、特惠关税等），依据企业提供的进口商品信息，<span>智能分析判定</span>，并推荐<span>最优关税</span>给到企业，让企业永远以最优关税进行商品申报。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s5">
        <div class="s5Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/d1.png" alt=""><div>涉证涉检</div></div></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/d2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/d3.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
          </Row>
          <Row type="flex">
            <Col span="5">&nbsp;</Col>
            <Col span="19">
              <div class="ssdesc">检验检疫和监管证件是企业进行进出口业务的先决条件。涉证涉检模块在用户输入商品品名或HS编码后，就为用户提供商品完整的贸易许可信息并随附商品相关税率信息，让用户<span>一键获取商品涉证信息</span>。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s6">
        <div class="s6Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/e1.png" alt=""><div>中美加征</div></div></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/e2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/e3.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
          </Row>
          <Row type="flex">
            <Col span="5">&nbsp;</Col>
            <Col span="19">
              <div class="ssdesc">自中美贸易摩擦以来从美国进口至中国的部分商品被加征了特别关税。系统提供了<span>最新的中美加征特别关税信息</span>，帮助企业及时了解从美国进口商品的最新税率信息。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s7">
        <div class="s7Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/f1.png" alt=""><div>双反查询</div></div></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/f2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/f3.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
          </Row>
          <Row type="flex">
            <Col span="5">&nbsp;</Col>
            <Col span="19">
              <div class="ssdesc">双反税率包括反倾销反补贴税率，由于双反税率信息一般会指定到某个贸易国别甚至精细到某个厂商某个商品，所以进出口企业在进口相关商品时可以通过查询双反税率信息及时<span>了解被双反限制的贸易国别、厂商和商品</span>，避免由于双反税率的影响导致进口税率激增。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s8">
        <div class="s8Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/g1.png" alt=""><div>CIQ查询</div></div></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/g2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/g3.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
          </Row>
          <Row type="flex">
            <Col span="5">&nbsp;</Col>
            <Col span="19">
              <div class="ssdesc">自2018年“关检融合”后，企业在进行进出口申报时就需要提供CIQ编码信息。但是CIQ码如何与商品编码进行匹配企业无所适从。CIQ码查询功能可以帮助企业了解到每个商品编码下的CIQ码范围及明细说明，<span>帮助企业一目了然的判别自己商品的CIQ码</span>，为企业进出口填制CIQ码提供信息支持。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s9">
        <div class="s9Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/h1.png" alt=""><div>3C认证查询</div></div></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/h2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/h3.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
          </Row>
          <Row type="flex">
            <Col span="5">&nbsp;</Col>
            <Col span="19">
              <div class="ssdesc">在进出口商品时由于中国检验检疫和国家质检总局的要求，会对特定的商品类型进行3C认证，由于3C认证体系与海关商品编码体系有所区别，所以很多企业都不知道自己的商品在进出口时是否会涉及到3C认证的问题。系统提供了3C认证查询功能，帮助<span>企业判断自己的商品是否涉及3C认证要求</span>。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s10">
        <div class="s10Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/j1.png" alt=""><div>出口退税</div></div></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/j2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/j3.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
          </Row>
          <Row type="flex">
            <Col span="5">&nbsp;</Col>
            <Col span="19">
              <div class="ssdesc">出口退税信息可以帮助企业了解最新的商品出口退税信息。帮助出口型企业及时了解退税税率，<span>做好相关的退税单证准备工作</span>。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s11">
        <div class="s11Wra">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/k1.png" alt=""><div>商品税费预估</div></div></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc"><img src="~@/assets/images/mb/k2.png" alt=""></Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
            <Col span="1"></Col>
            <Col span="4" class="sdesc">&nbsp;</Col>
          </Row>
          <Row type="flex">
            <Col span="5">&nbsp;</Col>
            <Col span="19">
              <div class="ssdesc">企业可以通过此功能实时计算进口某项商品使用协定税率与不使用协定税率之间的关税差异，帮助企业直观了解RCEP和其他自贸协定为企业带来的优惠关税红利有多大。同时系统还会同步计算其他相关税费信息，<span>帮助企业了解进出口贸易成本</span>。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s12">
        <div class="s12Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/l1.png" alt=""><div>消费税率</div></div></Col>
            <Col span="1"></Col>
            <Col span="19">
              <div class="ssdesc">消费税率信息查询。中国对于某些特定商品制定了消费税率。系统提供的消费税率信息查询，可以让企业了解自己的商品在进口时是否会涉及到消费税率，帮助企业<span>获得全面的涉税信息</span>，做好全面的税费筹划工作。</div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s13" style="margin-bottom:20px">
        <div class="s13Wrap">
          <Row type="flex">
            <Col span="4"><div class="stitle"><img src="~@/assets/images/mb/m1.png" alt=""><div>海关汇率</div></div></Col>
            <Col span="1"></Col>
            <Col span="19">
              <div class="ssdesc">海关进行外币计价时用的是海关汇率。海关汇率是为上一个月第三个星期三（第三个星期三为法定节假日的，顺延采用第四个星期三）中国人民银行公布的外币对人民币的 基准汇率。因此很多企业在计算海关汇率时都需要去网站上到处查找，容易出错。系统提供了海关汇率查询，企业只需要录入年份和月份就可以获得<span>当期及历史的海关汇率信息，简单又准确</span>，方便企业获得相关的海关汇率情况。</div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mobile'
}
</script>

<style scoped>
.results{
  position: relative;
  padding: 15px 0 25px;
  color: #333;
}
.results-wrap{
  width:1400px;
  margin: 0 auto;
  padding-bottom: 20px;
  max-width: var(--contentPageMaxWidth);
}
.headtitle{
  font-size: 2.6rem;
  margin-top: 10px;
  margin-bottom: 30px;
  font-weight: bold;
  color: #333;
  padding-left: 30px;
}
.headdesc{
  background-color: #ecfbff;
  padding: 20px 30px;
  font-size: 16px;
  line-height: 26px;
  text-align: justify;
}
.s1, .s2, .s3, .s4, .s5, .s6, .s7, .s8, .s9, .s10, .s11, .s12, .s13{
  margin-top: 40px;
}
.s1 .s1Wrap{
  padding: 0 110px;
}
.s1 .title{
  font-size: 2.4rem;
  font-weight: bold;
  margin-bottom: 15px;
}
.s1 .item{
  font-size: 16px;
  color: #595959;
  letter-spacing: 1px;
  margin-bottom: 12px;
}
.stitle{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 110px;
}
.stitle img{
  width: 80px;
}
.stitle div{
  text-align: center;
  font-size: 18px;
  margin-top: 10px;
  white-space: nowrap;
}
.sdesc img{
  width: 100%;
}
.ssdesc{
  font-size: 16px;
  margin-top: 20px;
  line-height: 26px;
  text-align: justify;
  text-indent: 16px;
}
.ssdesc span{
  color: red;
  font-weight: bold;
  font-size: 20px;
}
</style>

<style>
@media print,screen and (min-width:2300px) {
  .helpmobile .headtitle{
    font-size: 3rem;
  }
  .helpmobile .headdesc{
    font-size: 18px;
  }
  .helpmobile .s1 .title{
    font-size: 2.6rem;
  }
  .helpmobile .s1 .item{
    font-size: 18px;
  }
  .helpmobile .stitle div{
    font-size: 2rem;
  }
  .helpmobile .ssdesc{
    font-size: 18px;
  }
  .helpmobile .ssdesc span{
    font-size: 22px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/help/Mobile.vue